import InvoicePaymentMethod from '@/domain/billing/entity/invoice-payment-link/invoice-payment-method';

export default class InvoicePaymentLink {
  country: string;

  paymentMethod?: InvoicePaymentMethod;

  paymentMethodFlow: string;

  constructor(obj: any = {}) {
    this.country = obj.country || '';
    this.paymentMethod = obj.paymentMethod || null;
    this.paymentMethodFlow = obj.paymentMethodFlow || '';
  }

  toRequest(): any {
    return {
      country: this.country,
      paymentMethodId: this.paymentMethod?.id,
      paymentMethodFlow: this.paymentMethodFlow,
    };
  }
}
